<template>
  <div v-if="seriesData !== null && seriesData.length > 0" class="l-series">
    <nuxt-link v-if="Object.keys(topicData).length > 0 && !isAmp" :to="`/topic/${topicData.topic_id}/`" :title="`前往${topicData.title}專題頁`" class="l-series__title">
      詳見更多「{{ topicData.title }}」新聞
    </nuxt-link>
    <a v-else-if="Object.keys(topicData).length > 0 && isAmp" :href="`/topic/${topicData.topic_id}/`" :title="`前往${topicData.title}專題頁`" class="l-series__title">
      詳見更多「{{ topicData.title }}」新聞
    </a>
    <h2 v-else class="l-series__title">
      {{ articleType === 'video' ? '相關影音' : '相關文章' }}
    </h2>
    <span />
    <ul>
      <li v-for="article in seriesData" :key="article.id">
        <nuxt-link v-if="article.url && !isAmp" :to="`${article.url}/`" title="前往新聞頁">
          {{ article.title }}
        </nuxt-link>
        <a v-else-if="article.url && isAmp" :href="`${article.url}/`" title="前往 CTWANT 新聞頁">
          {{ article.title }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SeriesArticles',
  props: {
    articleType: {
      type: String,
      required: true
    },
    seriesData: {
      required: true,
      type: Array,
      default() {
        return []
      }
    },
    topicData: {
      type: Object,
      required: false,
      default() {
        return {}
      }
    },
    isAmp: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.l-series{
  margin-bottom: 35px;
  >h2, >a{
    display: inline-block;
    padding: 5px 7px;
    padding-right: 30px;
    color: $white;
    background: linear-gradient(65deg, $primary 0%, $primary 80.5%, $primary 80.5%, transparent 80.6%, transparent 100%);
    font-weight: normal;
    font-size: $font-m;
  }
  >a{
    padding-right: 55px;
    background: linear-gradient(65deg, $primary 0%, $primary 88.5%, $primary 88.5%, transparent 88.6%, transparent 100%);
  }
  >span{
    display: block;
    width: 100%;
    height: 3px;
    background-color: $primary;
  }
  >ul{
    padding: 0;
    margin: 8px 0;
    background-color: #f6f6f6;
    li{
      list-style: none;
      padding: 0 12px;
      &:not(:last-child)::after{
        content: "";
        display: block;
        width: 100%;
        height: 1px;
        background-color: #dedede;
      }
      >a{
        display: block;
        color: $black;
        line-height: 20px;
        padding: 8px;
        &:hover{
          color: $primary;
        }
        @include pad{
          padding: 8px 0px;
        }
      }
    }
  }
}
</style>
